import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { RouterStore } from '@estee/elc-router';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { SignInType } from '~constants/SignInTypeEnum';
import { UserRepository } from '~repositories/UserRepository';
import { GoToLandingViewUseCase } from './GoToLandingViewUseCase';
import { genericSocialErrorMessage } from '~constants/Constants';

export class DisconnectSocialUseCase {
    private routerStore: RouterStore;
    private configRepository: ConfigRepository;
    private socialProvider: SignInType;
    private userRepository: UserRepository;

    constructor(provider: SignInType) {
        this.routerStore = diContainer.get(serviceNames.routerStore);
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.userRepository = diContainer.get(serviceNames.userRepository);
        this.socialProvider = provider;
    }
    execute = async () => {
        if (this.socialProvider) {
            const error = await this.userRepository.disconnectSocial(this.socialProvider);
            if (error) {
                await new GoToLandingViewUseCase(genericSocialErrorMessage).execute();
            } else {
                this.routerStore.changeLocation(this.configRepository.onSuccessRedirectUrl);
            }
        }
    };
}
